// extracted by css-extract-rspack-plugin
export default {"content":"NewAgentTaskForm-module__content__aSNok","header":"NewAgentTaskForm-module__header__P8xhF","skeleton":"NewAgentTaskForm-module__skeleton___zy4S"};